import React from 'react'
import css from './styles.module.scss'
import cn from 'classnames'
import { getAssigneeLanding1Route } from 'routes'
import gql from 'graphql-tag'
import PageWrapper from 'components/PageWrapper'
import Paper from 'components/Paper'
import Segment from 'components/Segment'
import Button, { Buttons } from 'components/Button'
import graphicDesignerSrc from 'assets/images/other/vacancy-graphic.png'
// import graphicCopywriterSrc from 'assets/images/other/vacancy-graphic.png'
import UserPreview, { userPreviewFragment } from 'components/UserPreview'
import { ReactComponent as IntroducingIcon1 } from 'assets/images/landing-assignee/introducing/1.svg'
import { ReactComponent as IntroducingIcon2 } from 'assets/images/landing-assignee/introducing/2.svg'
import { ReactComponent as IntroducingIcon3 } from 'assets/images/landing-assignee/introducing/3.svg'
import howImgSrc1 from 'assets/images/landing-assignee/how/1.png'
import howImgSrc2 from 'assets/images/landing-assignee/how/2.png'
import howImgSrc3 from 'assets/images/landing-assignee/how/3.png'
import SocialIcon from 'components/SocialIcon'
import iphoneImageSrc from 'assets/images/other/iphone.jpg'
import RichText from 'components/RichText'
// import { toPrettyText } from 'components/PrettyText'
import moment from 'moment'

const VacancyLandingPage = ({ match }) => {
  const cityAlias = match.params.cityAlias
  const vacancyAlias = match.params.vacancyAlias
  const cities = {
    london: 'London',
    manchester: 'Manchester',
    birmingham: 'Birmingham',
    leeds: 'Leeds',
    glasgow: 'Glasgow',
    southampton: 'Southampton',
    liverpool: 'Liverpool',
    newcastle: 'Newcastle',
    nottingham: 'Nottingham',
    sheffield: 'Sheffield',
  }
  const vacancies = {
    'graphic-designer': {
      shortTitle: 'Graphic Designer',
      text:
        '<p><strong>Overview</strong></p><p>SureTask is looking for skilled Graphic Designers to start work immediately.</p><p>Get Graphic Designer work on SureTask. Visit SureTask website, sign-up and start earning today.</p><p>SureTask is an online marketplace for local services that helps UK customers quickly and safely find trusted contractors for personal and business needs.</p><p> </p><p><strong>Role Profile</strong></p><p>We are looking for a great designer to work on a range of design projects from marketing collateral to exhibits and everything in between.</p><p>This is a great opportunity to demonstrate your diverse digital skill set and have input in some online work.</p><p>We want creative and professional graphic designers who are passionate about the quality of their work.</p><p>You are a natural problem-solver, highly creative, love sharing and exploring ideas and have an imaginative and curious mind.</p><p> </p><p><strong>Duties may include</strong></p><p>· Developing content and artwork required by stakeholders</p><p>· Design and edit graphics and layouts for printed materials such as flyers, catalogues, adverts, packaging and user guides for products</p><p>· Owning imagery styles including video, photography, graphics, schematics, icons, infographics, animations and transition styles</p><p>· Projects may include branding, web design, print projects (posters, cards), and more</p><p>· Producing design requirements across the business for print, media, social and digital</p><p> </p><p><strong>Benefits</strong></p><p>· Get notified about new jobs - Connect with customers instantly</p><p>· Regular work - Hundreds of jobs posted daily</p><p>· You set the price - You decide how much to earn</p><p>· Flexible - Work on your own schedule</p><p>· Build your reputation - The higher your rating. The more work you will secure</p><p>· Start work immediately - Sign-up now and start making offers</p>',
      salary: '£60 to £180 per hour',
      category: 'Design and Web',
      graphicSrc: graphicDesignerSrc,
    },
    copywriter: {
      shortTitle: 'Copywriter',
      text: `<h2>Overview</h2><p>SureTask is looking for a talented and enthusiastic Copywriter to start work immediately.</p><p>Get Copywriter work on SureTask. Visit SureTask website, sign-up and start earning today.</p><p>SureTask is an online marketplace for local services that helps UK customers quickly and safely find trusted contractors for personal and business needs.</p><h2>Role Profile</h2><p>We are looking for a great Copywriter creating copy for a variety of internal and external channels, for both digital and print.</p><p>This is a great opportunity to demonstrate your diverse writing skill set and have input in some online work.</p><p>We want creative and professional Copywriters who are passionate about the quality of their work.</p><p>You are a natural problem-solver, highly creative, love sharing and exploring ideas and have an imaginative and curious mind.</p><p>You will be responsible for creating copy across web, social, emails, presentations as well as writing video scripts, authoring & updating documents and manuals, explaining information in a clear and concise manner and much more. Along with this, there will also be opportunities to develop your storytelling through animations and podcasts.</p><h2>Duties may include</h2><ul> <li>Delivering copy requirements within timeframe and to budget in response to client briefs</li><li>Crafting compelling stories that speak to the target audience and achieve the client's communication objectives</li><li>Writing SEO driven copy for blogs, pages and platforms</li><li>Amending, revising or redeveloping digital content or campaigns in response to feedback from the customers</li><li>Producing creative and engaging copy for email, social media and Facebook/Google ads</li></ul> <h2>Benefits</h2><ul><li>Get notified about new jobs - Connect with customers instantly</li><li>Regular work - Hundreds of jobs posted daily</li><li>You set the price - You decide how much to earn</li><li>Flexible - Work on your own schedule</li><li>Build your reputation - The higher your rating. The more work you will secure</li><li>Start work immediately - Sign-up now and start making offers</li></ul>`,
      salary: '£15 to £35 per hour',
      category: 'PR, Advertising & Marketing Jobs',
    },
    handyman: {
      shortTitle: 'Handyman',
      text: `<h2>Overview</h2><p>SureTask is looking for Multi-skilled Handymen / tradesmen to start work immediately.</p> <p>Get Handymen work on SureTask. Visit SureTask website, sign-up and start earning today.</p><p>SureTask is an online marketplace for local services that helps UK customers quickly and safely find trusted contractors for personal and business needs.</p><h2>Role Profile</h2><p>We are looking for a professional handyman or handywoman to be able to perform a range of duties such as being able to create materials that fit the client's expectations. Assemble sturdy and well-constructed floorboards, skirting boards, window frames, doors, door linings, staircases, fitted furniture, cabinetry and shelving.</p><p>This is a great opportunity to demonstrate your skill set and to choose your own working hours and take days off when you need them.</p><p>We want professionals who are passionate about the quality of their work.</p> <p>Must be reliable, flexible and a good timekeeper. </p><p>You are a natural problem-solver, highly creative, love sharing and exploring ideas and have an imaginative and curious mind.</p> <h2>Duties may include</h2><ul><li>Preparing / making good properties</li><li>Painting & decorating</li><li>General carpentry</li><li>Basic plumbing & electrical duties</li><li>Fixing / replacing locks</li><li>Flooring and tiling</li><li>General handyman skills</li></ul><h2>Benefits</h2> <ul><li>Get notified about new jobs - Connect with customers instantly</li><li>Regular work - Hundreds of jobs posted daily</li><li>You set the price - You decide how much to earn</li><li>Flexible - Work on your own schedule</li> <li>Build your reputation - The higher your rating. The more work you will secure</li><li>Start work immediately - Sign-up now and start making offers</li></ul>`,
      salary: '£50 to £150 per hour',
      category: 'Trade & Construction Jobs',
    },
  }
  const cityTitle = cities[cityAlias]
  const rawVacancy = vacancies[vacancyAlias]
  const vacancy = rawVacancy &&
    cityTitle && {
      shortTitle: rawVacancy.shortTitle,
      fullTitle: rawVacancy.shortTitle + ' in ' + cityTitle,
      salary: rawVacancy.salary,
      location: cityTitle,
      category: rawVacancy.category,
      text: rawVacancy.text,
      graphicSrc: rawVacancy.graphicSrc,
    }
  const schemaOrg = {
    '@context': 'https://schema.org/',
    '@type': 'JobPosting',
    title: vacancy.fullTitle,
    description: vacancy.text,
    identifier: {
      '@type': 'PropertyValue',
      name: 'SureTask',
      value: 'SureTask',
    },
    datePosted: moment().startOf('week'),
    validThrough: moment()
      .startOf('week')
      .add(7, 'days'),
    employmentType: 'CONTRACTOR',
    hiringOrganization: {
      '@type': 'Organization',
      name: 'SureTask',
      sameAs: 'https://suretask.com',
      logo: 'https://suretask.com/icon-192.png',
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        // streetAddress: job.address,
        addressCountry: 'UK',
        addressRegion: vacancy.city,
        addressLocality: vacancy.city,
      },
    },
  }
  return (
    <PageWrapper
      query={gql`
        query($input3: GetUsersInput!) {
          getCategoryGroups {
            categoryGroups {
              id
              title
              alias
              categories {
                id
                title
                alias
              }
            }
          }
          getUsers(input: $input3) {
            users {
              ...UserPreview_user
            }
          }
          getMe {
            me {
              id
            }
          }
        }
        ${userPreviewFragment}
      `}
      variables={{
        input3: {
          limit: 30,
        },
      }}
      parser={[
        ['categoryGroups', 'getCategoryGroups.categoryGroups'],
        ['jobs', 'getJobs.jobs'],
        ['user', 'getUser.user'],
        ['users', 'getUsers.users'],
        ['me', 'getMe.me'],
      ]}
      checkExists={() => !!vacancy}
    >
      {({ categoryGroups, jobs, user, users, me }) => (
        <>
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }} />
          <div className={cn(css.vacancy, css.section)}>
            <div className={css.wrapper}>
              <Paper>
                <Segment title={vacancy.shortTitle} desc={vacancy.location}>
                  <p className={css.buttonPlace1}>
                    <Button color="green" shadow to={getAssigneeLanding1Route()}>
                      Apply Now
                    </Button>
                  </p>
                  <RichText dangerouslySetInnerHTML={{ __html: vacancy.text }} className={css.text} />
                  <div className={css.detailsSection}>
                    <h2 className={css.detailsTitle}>Job Details</h2>
                    <div className={css.details}>
                      <div className={css.detail}>
                        <b>Job Location:</b> {vacancy.location}
                      </div>
                      <div className={css.detail}>
                        <b>Job Type:</b> {vacancy.category}
                      </div>
                      <div className={css.detail}>
                        <b>Salary Range:</b> {vacancy.salary}
                      </div>
                    </div>
                  </div>
                  <p className={css.buttonPlace2}>
                    <Button color="green" shadow to={getAssigneeLanding1Route()}>
                      Apply Now
                    </Button>
                  </p>
                  {vacancy.graphicSrc && (
                    <div className={css.graphicSection}>
                      <h2 className={css.graphicTitle}>Salary Comparsion:</h2>
                      <div className={css.graphic}>
                        <img alt="" src={vacancy.graphicSrc} className={css.img} />
                      </div>
                    </div>
                  )}
                </Segment>
              </Paper>
            </div>
          </div>

          <div className={cn(css.users, css.section)}>
            <div className={css.wrapper}>
              <h2 className={cn(css.sectionTitle, css.title)}>Service Providers</h2>
              <div className={css.usersWrapper}>
                <div className={css.usersPlace}>
                  {users.map((user, i) => (
                    <UserPreview user={user} key={i} me={me} />
                  ))}
                  {users.map((user, i) => (
                    <UserPreview user={user} key={i + '_1'} me={me} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className={cn(css.introducing, css.section)}>
            <div className={css.wrapper}>
              <h2 className={cn(css.sectionTitle, css.title)}>Introducing SureTask</h2>
              <div className={css.content}>
                <p>
                  SureTask is a convenient service that helps UK customers quickly and easily find trusted contractors
                  for personal and business needs.
                </p>
                <p>
                  Our goal is to build a trusted community platform that connects people who need to outsource tasks and
                  find local services, with people who are looking to earn money and ready to work.
                </p>
              </div>
              <div className={css.items}>
                <div className={css.item}>
                  <div className={css.pic}>
                    <p className={css.number}>1</p>
                    <IntroducingIcon1 className={css.icon} />
                  </div>
                  <p className={css.text}>Create your user profile</p>
                </div>
                <div className={css.item}>
                  <div className={css.pic}>
                    <p className={css.number}>2</p>
                    <IntroducingIcon2 className={css.icon} />
                  </div>
                  <p className={css.text}>Get matched with customers</p>
                </div>
                <div className={css.item}>
                  <div className={css.pic}>
                    <p className={css.number}>3</p>
                    <IntroducingIcon3 className={css.icon} />
                  </div>
                  <p className={css.text}>Win the task</p>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(css.howItWorks, css.section)}>
            <div className={css.wrapper}>
              <h2 className={cn(css.sectionTitle, css.title)}>How SureTask works</h2>
              <div className={css.items}>
                <div className={css.item}>
                  <p className={css.imgPlace}>
                    <img alt="" src={howImgSrc1} className={css.img} />
                  </p>
                  <p className={css.itemTitle}>Customer places an ad</p>
                  <p className={css.text}>Customer describes job that needs to be done.</p>
                </div>
                <div className={css.item}>
                  <p className={css.imgPlace}>
                    <img alt="" src={howImgSrc2} className={css.img} />
                  </p>
                  <p className={css.itemTitle}>Select the one you want to complete</p>
                  <p className={css.text}>
                    Browse a list of tasks, check the job details and reply quickly. It’s now up to you to win the job.
                  </p>
                </div>
                <div className={css.item}>
                  <p className={css.imgPlace}>
                    <img alt="" src={howImgSrc3} className={css.img} />
                  </p>
                  <p className={css.itemTitle}>Win the task</p>
                  <p className={css.text}>
                    Meet customers through our platform. Confirm details with your customer. Complete the task nad
                    submit your feedback.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(css.tellMeMore, css.section)}>
            <div className={css.wrapper}>
              <h2 className={cn(css.sectionTitle, css.title)}>Ok, tell me more</h2>
              <div className={css.items}>
                <div className={css.item}>
                  <p className={css.itemTitle}>How much will it cost me?</p>
                  <p className={css.text}>
                    Creating an account is free. There’s no signup or subscription fee. You only pay £1 when you find a
                    matching customer's task and send a bid. If the customer does not choose a service provider within 7
                    days then we'll refund your bid in SureTask credit. We will credit you with £5 to try our service.
                  </p>
                </div>
                <div className={css.item}>
                  <p className={css.itemTitle}>What kinds of jobs can i get?</p>
                  <p className={css.text}>
                    Customers come to SureTask to get all kinds of projects done. From fixing a leaking tap to a total
                    home remodel — pretty much anything. That means your jobs can range in size, whether you want to
                    pick up small jobs here and there, or you’re looking for your next big job. Just create business
                    profile and start receiving leads.
                  </p>
                </div>
                <div className={css.item}>
                  <p className={css.itemTitle}>Why do customers use SureTask?</p>
                  <p className={css.text}>
                    SureTask shows customers the pros who are available, ready and willing to do exactly what they need.
                    They can see prices up front, view a professional’s past work, read reviews and see if the pro
                    they’re hiring has a background check or valid license.
                  </p>
                </div>
                <div className={css.item}>
                  <p className={css.itemTitle}>How do I find tasks on SureTask?</p>
                  <p className={css.text}>
                    When a customer needs a professional, they’ll put in their location and their task details. Then we
                    show you a list of tasks that could be a good fit. If what you want matches what they want, we’ll
                    put tasks on that list.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(css.contacts, css.section)}>
            <div className={css.wrapper}>
              <h2 className={cn(css.sectionTitle, css.title)}>Contacts</h2>
              <div className={css.items}>
                <div className={css.item}>
                  <p className={css.label}>Email us</p>
                  <p className={css.value}>
                    <a href="mailto:support@suretask.com">support@suretask.com</a>
                  </p>
                </div>
                <div className={css.item}>
                  <p className={css.label}>Follow us</p>
                  <Buttons>
                    <a href="https://www.facebook.com/SureTask.co.uk">
                      <SocialIcon name="facebook" />
                    </a>
                    <a href="https://www.instagram.com/SureTask.co.uk/">
                      <SocialIcon name="instagram" />
                    </a>
                  </Buttons>
                </div>
                <div className={css.item}>
                  <p className={css.label}>Chat with us</p>
                  <p className={css.value}>The chat icon in the bottom right of your screen</p>
                </div>
              </div>
              <div className={css.iphonePlace}>
                <img alt="" src={iphoneImageSrc} className={css.iphone} />
              </div>
            </div>
          </div>
        </>
      )}
    </PageWrapper>
  )
}

export default VacancyLandingPage
